import React from 'react';
import cx from 'classnames';
import styles from './LoadSpinner.scss';

const LoadSpinner = props => {
  return (
    <div
      className={cx(
        { [props.className]: !!props.className },
        styles.load_spinner
      )}
    >
      <div
        className={cx(styles.ring_parent, {
          [props.ringClassName]:
            props.ringClassName && typeof props.ringClassName === 'string'
        })}
      >
        <div className={styles.ring}></div>
        <div className={styles.ring}></div>
        <div className={styles.ring}></div>
        <div className={styles.ring}></div>
      </div>
    </div>
  );
};

export default LoadSpinner;
